
@if (isSvg()) {
  <div class="d-flex"
    [style.height]="height"
    [style.width]="width"
    [innerHTML]="svgContent"
    [style.fill]="currentColor" >
  </div>
} @else {
  <img [src]="path()"  [style.height]="height" [style.width]="width" />
}
